const SCALE = {
  WIDTH700: '/scale/width/700',
  WIDTH200: '/scale/width/200',
  WIDTH300: '/scale/width/300',
  WIDTH344: '/16x9/scale/width/344',
};

class ImageProperties {
  static get WIDTH700() {
    return SCALE.WIDTH700;
  }

  static get WIDTH200() {
    return SCALE.WIDTH200;
  }

  static get WIDTH300() {
    return SCALE.WIDTH300;
  }

  static get WIDTH344() {
    return SCALE.WIDTH344;
  }
}

export default ImageProperties;
